module.exports = __webpack_public_path__ + "img/under-pressure-male.03131136.png";